import React from 'react';
import { useNavigate } from 'react-router-dom';
import BookingWidget from '../components/BookingWidget';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiShield } = FiIcons;

const BookDemoPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <button onClick={() => navigate('/')} className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors">
              <SafeIcon icon={FiArrowLeft} /> 
              <span>Tilbake</span>
            </button>
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiShield} className="text-blue-600 text-xl" />
              <span className="font-bold text-gray-900 text-lg">HMSvarsling</span>
            </div>
            <div className="w-20"></div> {/* Spacer for centering */}
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Se plattformen i aksjon</h1>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Bestill en uforpliktende gjennomgang med en av våre eksperter. Vi viser deg hvordan systemet løser dine behov.
          </p>
        </div>

        <BookingWidget />

        <div className="mt-12 text-center text-sm text-gray-500">
          <p>Møtet foregår via Google Meet eller Teams. Du trenger ikke installere noe.</p>
        </div>
      </div>
    </div>
  );
};

export default BookDemoPage;